import React from 'react'
import image from '../../../../../../../../assets/images/report-sent.svg'
import imageZj from '../../../../../../../../assets/images/report-sent-zj.svg'
import { Title, Description, CenteredContainer } from './mixins'
import { portalsBySiteId } from '../../../../../../../../constants/portalesBySiteId'
import { IS_ZONA_JOBS, SITE_ID } from '../../../../../../../../constants'

const Component = () => {
  return (
    <CenteredContainer>
      <img src={IS_ZONA_JOBS ? imageZj : image} alt="Denuncia enviada" />
      <Title>Ya enviamos tu denuncia</Title>
      <Description>Nuestro equipo de fraudes va a revisar el caso y a tomar la acción correspondiente.</Description>
      <Description>
        Muchas gracias por contribuir a que {portalsBySiteId[SITE_ID || 'BMAR']} sea un lugar más seguro.
      </Description>
    </CenteredContainer>
  )
}

export default Component
